import FileHandler from '@adsk/alloy-react-file-handler';

const getFileHandlerVariant = ({
  loading,
  error,
  success,
  isDeleted,
}: {
  loading?: boolean;
  error?: unknown;
  success?: boolean;
  isDeleted?: boolean;
}): string => {
  if (error) {
    return FileHandler.VARIANTS.ERROR;
  } else if (loading) {
    return FileHandler.VARIANTS.LOADING;
  } else if (isDeleted) {
    return FileHandler.VARIANTS.REMOVED;
  } else if (success) {
    return FileHandler.VARIANTS.SUCCESS;
  }

  return FileHandler.VARIANTS.DEFAULT;
};

export default getFileHandlerVariant;
